import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import MultiInput from 'modules/core/components/MultiInput'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  form: PlannedBreakForm
  error?: string
  hideError?: boolean
  showNotice?: boolean
  newVersion?: boolean
}

const FlexibleBreakInputs = ({
  form,
  error,
  hideError = false,
  showNotice = false,
  newVersion = false,
}: Props) => {
  const field = form.get('duration')
  const localErrors = field.errors || []
  const fieldError = error || localErrors[0]

  return (
    <MultiInput>
      <Box gap="s16" className={fieldError && 'error-anchor'}>
        <Box gap="s4">
          <Box flexDirection="row" alignItems="center" gap="s12">
            {newVersion && (
              <TooltipIcon.Medium
                icon="clock"
                label={i18n.t('company_settings.time.breaks.duration')}
                color="grey1000"
              />
            )}
            <Box flexDirection="row" gap="s8" alignItems="center">
              <Box width="fit-content">
                <TextField
                  hideLabel
                  label={i18n.t('company_settings.time.breaks.duration')}
                  type="number"
                  value={field.value.toString()}
                  onChange={(duration) => field.set(duration)}
                  onBlur={() => field.setErrors([])}
                  placeholder="--"
                  isNotValid={!!fieldError}
                />
              </Box>
              <Box
                background="grey200"
                padding="s8"
                borderRadius={{
                  all: 'abs008',
                }}
                border={{
                  all: {
                    width: 's2',
                    style: 'solid',
                    color: 'grey400',
                  },
                }}
              >
                <Text.Normal>{i18n.t('common.minutes')}</Text.Normal>
              </Box>
            </Box>
          </Box>
          {fieldError && !hideError && (
            <Text size="200" color="radicalRed1000" capitalize>
              {fieldError}
            </Text>
          )}
        </Box>
        {showNotice && (
          <Text size="200" capitalize>
            {i18n.t('shift_management.breaks.notice.flexible')}
          </Text>
        )}
      </Box>
    </MultiInput>
  )
}

export default observer(FlexibleBreakInputs)
